<template>
  <div class="contact-frame" v-if="communications.value.length">
    <template v-if="mainContacts && mainContacts.length">
      <div
        v-for="contact in mainContacts"
        :key="contact.id"
        class="contact-frame-socials"
      >
        <p>{{ contactLabel(contact.value_type) }}</p>
        <p class="links">
          <a
            :title="contact.label"
            :href="contactLink(contact.value_type, contact.value)"
            target="_blank"
          >
            {{ contact.value }}
          </a>
          <span
            v-if="!!communications?.access_telephony"
            @click="call(contact)"
            class="oms-call"
          >
            <Icon v-if="contact.value_type == 'phone'" iconName="oms-call" />
          </span>
          <a
            v-if="contact.value_type == 'phone'"
            title="Whatsapp"
            :href="contactLink('whatsapp', contact.value)"
            target="_blank"
          >
            <contact-icons iconName="phone" />
          </a>

          <a
            v-if="contact.value_type == 'phone'"
            title="Telegram"
            :href="contactLink('telegramNumber', contact.value)"
            target="_blank"
          >
            <contact-icons iconName="telegram" />
          </a>

          <copy-button
            v-if="contact.value_type == 'email'"
            :text="contact.value"
          />
        </p>
      </div>
    </template>
    <template v-if="socialContacts && socialContacts.length">
      <div class="contact-frame-socials">
        <p>Соц. сети</p>
        <a
          v-for="contact in socialContacts"
          :key="contact.id"
          :href="contactLink(contact.value_type, contact.value)"
          target="_blank"
          class="links"
        >
          <!-- {{ socialContacts }} -->
          {{
            socialContacts.indexOf(contact) > 0
              ? `, ${contact.label || contactLabel(contact.value_type)}`
              : contact.label || contactLabel(contact.value_type)
          }}
          <!-- <contact-icons :iconName="contact.value_type" /> -->
        </a>
      </div>
    </template>
  </div>
  <div v-else>
    <div class="contact-frame-none">
      <p>Нет контактов</p>
    </div>
  </div>
</template>
<script>
import { store } from '@/store';
import { getController } from '@/controllers/request';
import { MODULE } from '@/utils/constants';
import { setContactData } from '@/utils/helpers';
import { metadata, errorMsg } from '@/utils/mixins';
import ContactIcons from 'Elements/SVG/ContactIcons';
import CopyButton from 'Elements/Button/CopyButton';
import Icon from 'Elements/Icon/Icon';

export default {
  mixins: [metadata, errorMsg],
  props: {
    communications: {
      type: Object,
      default() {
        return {
          option: {},
          value: []
        };
      }
    }
  },
  data() {
    return {
      module: MODULE.CANDIDATES_MODULE,
      form: {},
      contactOpts: {},
      loading: false
    };
  },
  created() {
    const { value, option, name = 'communications' } = this.communications;
    this.$set(this.form, name, value || []);
    this.setCommunications(value, option || {});
    this.$emit('set-loading', false);
  },
  computed: {
    mainContacts() {
      return this.communications.value
        .filter(contact =>
          this.communications.config.priority.includes(contact.value_type)
        )
        .sort((a, b) => {
          const indexA = this.communications.config.priority.findIndex(
            type => type === a.value_type
          );
          const indexB = this.communications.config.priority.findIndex(
            type => type === b.value_type
          );
          return indexA - indexB;
        });
    },
    socialContacts() {
      return this.communications.value.filter(
        contact =>
          // !this.communications.config.excluded.includes(contact.value_type) &&
          !this.communications.config.priority.includes(contact.value_type)
      );
    },
    noAccessByRole() {
      return (
        store.state.candidate.vacanciesForCall &&
        store.state.candidate.vacanciesForCall.hasOwnProperty('role_access') &&
        !store.state.candidate.vacanciesForCall?.role_access
      );
    }
  },
  methods: {
    contactLink(type, val) {
      return setContactData(type, val).link;
    },
    contactLabel(type) {
      return this.communications.option.value_type_list[type];
    },
    async call(contact) {
      if (!this.communications?.access_telephony) return;

      try {
        if (!store.state.candidate.vacanciesForCall) {
          const params = {
            action: 'get_RightPanel',
            module: 'HRPAC_SELECTION_STAGE_CANDIDATES_1',
            candidate_id:
              this.$route.name == 'candidateId'
                ? this.$route.params.id
                : store.state.vacancy.currentVacancyCandidate.ID,
            content_type: 'cand_card'
          };

          const resp = await getController({
            params
          });

          if (resp.data) {
            store.commit(
              'candidate/setVacancies',
              resp.data?.content?.data || null
            );
          }
        }

        if (this.noAccessByRole) {
          this.showErrorMessage(
            'Нет доступа к списку вакансий для совершения вызова'
          );
        }

        store.dispatch('candidate/checkForCall', contact.id);
      } catch (error) {
        console.error(error);
      }
    }
  },
  components: { ContactIcons, CopyButton, Icon }
};
</script>
<style lang="scss" scoped>
.contact-frame {
  &-none {
    background-color: $black-10;
    text-align: center;
    padding: 8px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 4px;
    justify-content: center;
    margin-top: 24px;
  }

  &-socials {
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    p {
      line-height: 24px;
      font-size: 15px;
      margin-right: 24px;
      width: 120px;
      margin-right: 16px;

      &:not(.links) {
        color: $grey40;
      }
    }

    .links {
      display: flex;
      width: auto;
      flex-direction: row;
      align-items: center;
      color: $blue64 !important;
      text-decoration: none !important;
      max-width: 260px;
      white-space: nowrap;

      a {
        margin-right: 8px;
        text-overflow: ellipsis;
        overflow: hidden;
        text-decoration: none !important;
      }

      .oms-call {
        cursor: pointer;
        margin-right: 8px;

        &--disabled {
          pointer-events: none;
        }
      }
    }
  }
}
</style>
